import React, { useContext, useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import './style.css';
import { roleContext } from '../../../context/role/context';

const ElectronicDocumentConsumption = () => {
    const [progress, setProgress] = useState(0);
    const { suscripcion } = useContext(roleContext);

    useEffect(() => {
        if (suscripcion?.electronic_documents) {
            const { limit, usage, is_unlimited } = suscripcion.electronic_documents;
            const percentage = (is_unlimited || limit <= 0) ? 0 : Math.min(Math.round((usage / limit) * 100), 100);

            const timer = setTimeout(() => {
                setProgress(percentage);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [suscripcion]);

    if (!suscripcion || !suscripcion.electronic_documents) {
        return null;
    }

    const { limit, usage, is_unlimited, additional_packages_limit, additional_packages_usage } = suscripcion.electronic_documents;
    const percentage = (is_unlimited || limit <= 0) ? 0 : Math.min(Math.round((usage / limit) * 100), 100);
    const remaining = is_unlimited ? null : Math.max(limit - usage, 0);
    const packageBalance = (additional_packages_limit || 0) - (additional_packages_usage || 0);

    return (
        <div className="consumption-container">
            <div className="consumption-left-section">
                <div className="consumption-icon-box">
                    <FileText size={24} className="consumption-icon" />
                </div>

                <div className="consumption-info">
                    <span className="consumption-label">DOCUMENTOS ELECTRÓNICOS</span>
                    <div className="consumption-value-wrapper">
                        <span className="consumption-usage">{usage}</span>
                        <span className="consumption-limit">de {is_unlimited ? '∞' : limit} consumidos</span>
                    </div>
                    {additional_packages_limit > 0 && (
                        <div className="consumption-package-info">
                            <span className="package-balance-label">Paquetes extra:</span>
                            <span className="package-balance-value">{packageBalance} disponibles</span>
                        </div>
                    )}
                </div>
            </div>

            {!is_unlimited && (
                <div className="consumption-center-section">
                    <div className="consumption-labels-row">
                        <span className="consumption-percentage-text">{percentage}% del límite mensual</span>
                        <span className="consumption-remaining-text">Quedan {remaining} documentos</span>
                    </div>
                    <div className="consumption-progress-bg">
                        <div
                            className="consumption-progress-bar"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                </div>
            )}

            {is_unlimited && (
                <div className="consumption-center-section">
                    <span className="consumption-unlimited-text">Plan sin límites de emisión</span>
                </div>
            )}
        </div>
    );
};

export default ElectronicDocumentConsumption;
